module.exports = __webpack_public_path__ + "static/media/admin.264fbc7d.svg";